"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import ItemLauncher from "./item-launchers/ItemLauncher.vue";
import ItemRenew from "./item-launchers/ItemRenew.vue";
import ItemRecycle from "./item-launchers/ItemRecycle.vue";
let ItemElementLauncher = class extends Vue {
  mounted() {
  }
  remoteLauncher() {
    this.$emit("remoteLauncher");
  }
  bindshop() {
    this.$emit("bindshop");
  }
  realDeleteVD() {
    this.$emit("realDeleteVD");
  }
};
__decorateClass([
  PropSync("item")
], ItemElementLauncher.prototype, "_item", 2);
ItemElementLauncher = __decorateClass([
  Component({
    components: {
      ItemLauncher,
      ItemRenew,
      ItemRecycle
    }
  })
], ItemElementLauncher);
export {
  ItemElementLauncher as default
};
